<div class="modal-content">
  <div class="modal-header">
    <p class="modal-title"><strong>{{getTitleKey() | translate}}</strong></p>
    <button type="button" class="close" (click)="closeDialog()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <mat-dialog-content style="overflow:visible">
      <form (ngSubmit)="save()" #f="ngForm" id="form"
            [formGroup]="formGroup" novalidate>
        <div class="row form-group" [ngClass]="{ 'has-danger': hasLocalFieldError('recipient') }">
          <label class="col-form-label form-control-label col-md-4 detail-title required-field-label">
            {{'COMMON_CONTACT_PERSON_PHONE_NUMBER' | translate}}
          </label>
          <div class="col-md-8">
            <div class="input-group">
              <input type="text" class="form-control"
                     [(ngModel)]="model.recipient"
                     formControlName="recipient"
                     [ngClass]="{ 'form-control-danger': hasLocalFieldError('recipient')}"
                     placeholder="{{'COMMON_CONTACT_PERSON_PHONE_NUMBER' | translate}}">
            </div>
            <div class="form-control-feedback" *ngIf="hasLocalFieldError('recipient')">
              <span
                *ngIf="hasLocalFieldError('recipient', 'validatePhoneNumber')">{{'COMMON_VALIDATION_MESSAGE_PHONE' | translate}}</span>
              <span
                *ngIf="hasLocalFieldError('recipient', 'required')">{{'COMMON_VALIDATION_MESSAGE_REQUIRED' | translate}}</span>
            </div>
          </div>
        </div>
        <div class="row form-group" [ngClass]="{ 'has-danger': hasLocalFieldError('content') }">
          <label
            class="col-form-label form-control-label col-md-4 detail-title required-field-label">{{'TASK_RECORD_OUTGOING_SMS_CONTENT' | translate}}</label>
          <div class="col-md-8">
            <div class="mw-100">
              <input type="text"
                     [(ngModel)]="model.content"
                     trim="blur"
                     validateOnBlur
                     [ngClass]="{ 'form-control-danger': hasLocalFieldError('content')}"
                     class="form-control"
                     name="content"
                     id="content"
                     formControlName="content"
                     placeholder="{{'TASK_RECORD_OUTGOING_SMS_CONTENT'|translate}}">
            </div>
            <div class="form-control-feedback" *ngIf="hasLocalFieldError('content')">
              <span
                *ngIf="hasLocalFieldError('content', 'required')">{{'COMMON_VALIDATION_MESSAGE_REQUIRED' | translate}}</span>
            </div>
          </div>
        </div>

        <div class="form-group row"
             [ngClass]="{ 'has-danger': hasLocalFieldError('integrationType') }">
          <div class="col-md-4">
            <label class="col-form-label mw-100 form-control-label required-field-label">
              {{'TRIGGER_SMS_INTEGRATION_TYPE'|translate}}
              <i class="icomoon icomoon-info info-icon" popover="{{'TRIGGER_SMS_INTEGRATION_TYPE_HINT' | translate}}"
                 triggers="mouseenter:mouseleave" container="body" placement="right">
              </i>
            </label>
          </div>
          <div class="col-md-8">
            <div class="mw-100">
              <angular2-multiselect [(ngModel)]="model.integrationType" [data]="integrationTypes"
                                    [settings]="singleLocalTranslateDropdownSettings"
                                    formControlName="integrationType">
              </angular2-multiselect>
              <div class="form-control-feedback"
                   *ngIf="hasLocalFieldError('integrationType')">
                {{'COMMON_VALIDATION_MESSAGE_REQUIRED' | translate}}
              </div>
            </div>
          </div>
        </div>


      </form>
    </mat-dialog-content>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-outline-primary" (click)="closeDialog()">
      {{'COMMON_BUTTON_CANCEL' | translate}}
    </button>
    <button type="submit" class="btn btn-primary" form="form">
      {{'COMMON_BUTTON_SAVE' | translate}}
    </button>
  </div>
</div>
